"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2547,5397],{

/***/ 14479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39653);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71197);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3382);
/* harmony import */ var src_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var Header = function Header(_ref) {
  var href = _ref.href,
      title = _ref.title,
      menuItems = _ref.menuItems;

  var _useDisclosure = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useDisclosure */ .qY)(),
      isOpen = _useDisclosure.isOpen,
      onToggle = _useDisclosure.onToggle;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
    className: "header-container",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      bg: "baseWhite",
      color: "baseNeutral.700",
      py: {
        base: 'xs',
        md: 'xl'
      },
      px: {
        base: 'm',
        md: 'xxl3'
      },
      borderBottom: 0,
      textAlign: "center",
      boxShadow: "0 2px 4px 0px rgba(0, 0, 0, 0.08)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        display: {
          base: 'block',
          md: 'none'
        },
        flex: "auto",
        ml: {
          base: -2
        },
        float: "left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .IconButton */ .hU, {
          onClick: onToggle,
          icon: isOpen ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__/* .CloseIcon */ .Tw, {
            w: 3,
            h: 3
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__/* .HamburgerIcon */ .Uq, {
            w: 5,
            h: 5
          }),
          variant: "ghost",
          "aria-label": "Toggle Navigation"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
        flex: {
          base: 1
        },
        justify: {
          base: 'center',
          md: 'start'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_1__/* .Logo */ .TR, {
          href: href,
          title: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_1__/* .OrganizationSchema */ .od, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
            display: {
              base: 'none',
              md: 'flex'
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
            ml: 10,
            display: {
              base: 'none',
              md: 'flex'
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_1__/* .MenuDesktop */ .WA, {
              items: menuItems
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      display: {
        base: 'block',
        md: 'none'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Collapse */ .UO, {
        in: isOpen,
        animateOpacity: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_1__/* .MenuMobile */ .XN, {
          items: menuItems
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Header);

/***/ }),

/***/ 42980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58598);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Actions = function Actions(_ref) {
  var active = _ref.active,
      primary = _ref.primary,
      hasSecondaryAction = _ref.hasSecondaryAction,
      secondary = _ref.secondary,
      inline = _ref.inline;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .SimpleGrid */ .MI, {
    columns: {
      base: inline && hasSecondaryAction ? 2 : 1,
      md: inline ? 2 : 1
    },
    spacing: {
      base: '1rem',
      md: inline ? '1.5rem' : '.5rem'
    },
    children: [hasSecondaryAction && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .SecondaryButton */ .kq, {
      title: secondary.title,
      action: secondary.action,
      onClick: secondary.onClick
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .PrimaryButton */ .KM, {
      title: primary.title,
      action: primary.action,
      onClick: primary.onClick,
      disabled: !active
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Actions);

/***/ }),

/***/ 55397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_OfferDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/switch/dist/index.esm.js
var dist_index_esm = __webpack_require__(68185);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(57543);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Title.tsx






var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      brandImage = _ref.brandImage,
      brandImageAlt = _ref.brandImageAlt;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
    templateColumns: {
      base: '1fr',
      md: '0.25fr 1fr'
    },
    alignItems: "center",
    children: [brandImage && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      p: 0,
      m: 0,
      h: "60px",
      display: {
        base: 'none',
        md: 'block'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        objectFit: "contain",
        src: brandImage,
        width: "60",
        height: "60",
        alt: brandImageAlt
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        as: "h1",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.75rem",
        letterSpacing: "0.86px",
        mt: "-7px",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        marginTop: "xs",
        color: "baseNeutral.700",
        fontFamily: "Montserrat-Medium",
        fontSize: "1.125rem",
        textTransform: "capitalize",
        lineHeight: "23.4px",
        letterSpacing: "0.3px",
        children: subtitle
      })]
    })]
  });
};

/* harmony default export */ var OfferDetails_Title = (Title);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Description.tsx


var _excluded = ["icon", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var BadgeWithIconCustom = function BadgeWithIconCustom(_ref) {
  var icon = _ref.icon,
      name = _ref.name,
      value = _ref.value,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* BadgeWithIcon */.eF, _objectSpread({
    icon: icon,
    name: name,
    value: value,
    fontFamily: "Montserrat-Regular, san-serif",
    fontSize: ".875rem",
    color: "#262626",
    marginBottom: "6px"
  }, others));
};

var Description = function Description(_ref2) {
  var fuelTitle = _ref2.fuelTitle,
      fuelValue = _ref2.fuelValue,
      transmissionTitle = _ref2.transmissionTitle,
      transmissionValue = _ref2.transmissionValue,
      powerTitle = _ref2.powerTitle,
      powerValue = _ref2.powerValue,
      priceValue = _ref2.priceValue,
      priceDescription = _ref2.priceDescription;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    textAlign: "left",
    position: "relative",
    marginTop: "1.3rem!important",
    marginBottom: "0",
    marginLeft: "-3px",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenFuelIcon */.af, {}),
      name: fuelTitle,
      value: fuelValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenTransmissionIcon */.Fe, {}),
      name: transmissionTitle,
      value: transmissionValue,
      marginLeft: "-2px"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenPowerIcon */.b3, {}),
      name: powerTitle,
      value: powerValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* PriceBox */.bz, {
      value: priceValue,
      description: priceDescription,
      textAlign: "right",
      position: "absolute",
      top: "-3px",
      right: "0"
    })]
  });
};

/* harmony default export */ var OfferDetails_Description = (Description);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Offer.tsx







var OfferDetails = function OfferDetails(_ref) {
  var sectionTitle = _ref.sectionTitle,
      durationTitle = _ref.durationTitle,
      durationValue = _ref.durationValue,
      distanceTitle = _ref.distanceTitle,
      distanceValue = _ref.distanceValue,
      depositTitle = _ref.depositTitle,
      depositValue = _ref.depositValue,
      depositDescription = _ref.depositDescription,
      onHoverMessage = _ref.onHoverMessage,
      expirationValue = _ref.expirationValue,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        display: "inline",
        fontSize: "1rem",
        lineHeight: "30.8x",
        letterSpacing: "0.2px",
        children: sectionTitle
      }), expirationValue && expirationValue.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* LimitedOfferBadge */.Ld, {
        display: "inline",
        float: "right",
        children: expirationValue
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
      columns: 3,
      spacing: ".688rem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardButton */.xC, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCalendarIcon */.cd, {}),
        title: durationTitle,
        description: durationValue,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardButton */.xC, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCarIconSecondary */.Mr, {}),
        title: distanceTitle,
        description: distanceValue,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardButton */.xC, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenPocketIcon */.ec, {}),
        title: depositTitle,
        description: "".concat(depositValue, " ").concat(depositDescription),
        onHoverMessage: onHoverMessage,
        onClick: onClick
      })]
    })]
  });
};

/* harmony default export */ var Offer = (OfferDetails);
// EXTERNAL MODULE: ./src/components/OfferDetails/Actions.tsx
var Actions = __webpack_require__(42980);
;// CONCATENATED MODULE: ./src/components/OfferDetails/index.tsx











var OfferDetails_OfferDetails = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      brandImage = _ref.brandImage,
      brandImageAlt = _ref.brandImageAlt,
      sectionTitle = _ref.sectionTitle,
      durationTitle = _ref.durationTitle,
      durationValue = _ref.durationValue,
      distanceValue = _ref.distanceValue,
      distanceTitle = _ref.distanceTitle,
      depositValue = _ref.depositValue,
      depositDescription = _ref.depositDescription,
      depositTitle = _ref.depositTitle,
      expirationValue = _ref.expirationValue,
      onHoverMessage = _ref.onHoverMessage,
      onClick = _ref.onClick,
      fuelTitle = _ref.fuelTitle,
      fuelValue = _ref.fuelValue,
      transmissionTitle = _ref.transmissionTitle,
      transmissionValue = _ref.transmissionValue,
      powerTitle = _ref.powerTitle,
      powerValue = _ref.powerValue,
      priceValue = _ref.priceValue,
      priceDescription = _ref.priceDescription,
      insurances = _ref.insurances,
      active = _ref.active,
      primary = _ref.primary,
      hasSecondaryAction = _ref.hasSecondaryAction,
      secondary = _ref.secondary;
  var dispatch = (0,es/* useDispatch */.I0)();
  var priceVatIncluded = (0,es/* useSelector */.v9)(function (state) {
    return state.nlt.priceVatIncluded;
  });

  var _useState = (0,react.useState)(false),
      priceVatIncludedChecked = _useState[0],
      setPriceVatIncludedChecked = _useState[1];

  (0,react.useEffect)(function () {
    return setPriceVatIncludedChecked(!priceVatIncluded);
  }, [priceVatIncluded]);

  var togglePriceVatIncluded = function togglePriceVatIncluded() {
    setPriceVatIncludedChecked(!priceVatIncludedChecked);
    dispatch((0,actions/* showPriceVatIncluded */.GR)(priceVatIncludedChecked));
  }; // @ts-ignore


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
    maxW: "6xl",
    px: 0,
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetails_Title, {
      title: title,
      subtitle: subtitle,
      brandImage: brandImage,
      brandImageAlt: brandImageAlt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      marginY: "m",
      color: "baseNeutral.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Offer, {
      sectionTitle: sectionTitle,
      durationTitle: durationTitle,
      durationValue: durationValue,
      distanceValue: distanceValue,
      distanceTitle: distanceTitle,
      depositValue: depositValue,
      depositDescription: depositDescription,
      depositTitle: depositTitle,
      expirationValue: expirationValue,
      onClick: hasSecondaryAction ? onClick : null,
      onHoverMessage: onHoverMessage
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetails_Description, {
      fuelTitle: fuelTitle,
      fuelValue: fuelValue,
      transmissionTitle: transmissionTitle,
      transmissionValue: transmissionValue,
      powerTitle: powerTitle,
      powerValue: powerValue,
      priceValue: priceValue,
      priceDescription: priceDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      mt: "-30px",
      textAlign: "right",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        as: "span",
        children: priceVatIncluded ? "IVA inclusa" : "IVA esclusa"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Switch */.r, {
        ml: "6px",
        colorScheme: "green",
        isChecked: priceVatIncluded,
        float: "right",
        value: "1",
        onChange: togglePriceVatIncluded
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      marginY: "m",
      color: "baseNeutral.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Actions/* default */.Z, {
      active: active,
      primary: primary,
      hasSecondaryAction: hasSecondaryAction,
      secondary: secondary,
      inline: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SimpleList */.LZ, {
      insurances: insurances
    })]
  });
});
OfferDetails_OfferDetails.displayName = 'OfferDetails';
/* harmony default export */ var components_OfferDetails = (OfferDetails_OfferDetails);

/***/ }),

/***/ 75713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rm": function() { return /* reexport */ components_Contact; },
  "W2": function() { return /* reexport */ components_Container; },
  "TR": function() { return /* reexport */ components_Logo; },
  "WA": function() { return /* reexport */ Menu_Desktop; },
  "M7": function() { return /* reexport */ MenuItem_Desktop; },
  "$w": function() { return /* reexport */ MenuItem_Mobile; },
  "XN": function() { return /* reexport */ Menu_Mobile; },
  "OA": function() { return /* reexport */ components_Newsletter; },
  "od": function() { return /* reexport */ components_OrganizationSchema; },
  "Pi": function() { return /* reexport */ components_Slider; }
});

// UNUSED EXPORTS: HeaderComponent, OfferDetails

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Logo/index.tsx




var Logo = function Logo(_ref) {
  var href = _ref.href,
      title = _ref.title,
      target = _ref.target;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
    href: href,
    target: target,
    title: title,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Img */.Ei, {
      src: "https://static1.carplanner.com/logos/carplanner.svg",
      alt: title,
      width: "15rem",
      height: "2.5rem",
      maxW: "15rem"
    })
  });
};

/* harmony default export */ var components_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(71197);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./src/components/MenuItem/Mobile.tsx






var MobileItem = function MobileItem(_ref) {
  var name = _ref.name,
      title = _ref.title,
      href = _ref.href,
      target = _ref.target,
      children = _ref.children;

  var _useDisclosure = (0,hooks_dist_index_esm/* useDisclosure */.qY)(),
      isOpen = _useDisclosure.isOpen,
      onToggle = _useDisclosure.onToggle;

  var handleToggle = function handleToggle() {
    if (children) {
      onToggle();
    }
  };

  var hasChildren = children && children.length > 0;
  return hasChildren ? /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
    spacing: 4,
    p: "m",
    py: "s",
    className: "menu-item-mobile",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
      py: 2,
      title: title,
      justify: "space-between",
      align: "center",
      _hover: {
        textDecoration: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
        title: title,
        target: target,
        fontFamily: "Montserrat-SemiBold",
        color: "baseNeutral.700",
        href: href,
        dangerouslySetInnerHTML: {
          __html: name
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
        as: icons_dist_index_esm/* ChevronRightIcon */.XC,
        color: "baseNeutral.700",
        transition: "all .25s ease-in-out",
        transform: isOpen ? 'rotate(90deg)' : '',
        w: 6,
        h: 6,
        onClick: handleToggle
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      mt: "0 !important",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
        in: isOpen,
        animateOpacity: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
          pl: 4,
          borderLeft: 1,
          borderStyle: "solid",
          borderColor: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('gray.200', 'gray.700'),
          align: "start",
          children: children.map(function (child) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
              href: child.href,
              title: child.title,
              target: child.target,
              py: 2,
              dangerouslySetInnerHTML: {
                __html: child.name
              }
            }, child.name);
          })
        })
      })
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
    p: "m",
    py: "s",
    className: "menu-item-mobile",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
      title: title,
      justify: "space-between",
      align: "center",
      _hover: {
        textDecoration: 'none'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
        title: title,
        target: target,
        py: 2,
        fontFamily: "Montserrat-SemiBold",
        color: "baseNeutral.700",
        href: href,
        dangerouslySetInnerHTML: {
          __html: name
        }
      }, name)
    })
  });
};

/* harmony default export */ var MenuItem_Mobile = (MobileItem);
;// CONCATENATED MODULE: ./src/components/MenuItem/Desktop.tsx






var DesktopItem = function DesktopItem(_ref) {
  var name = _ref.name,
      title = _ref.title,
      href = _ref.href,
      target = _ref.target,
      description = _ref.description;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
    href: href,
    title: title,
    role: "group",
    display: "block",
    p: 2,
    rounded: "md",
    target: target,
    _hover: {
      bg: 'primaryGreen.800'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
      direction: "row",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          transition: "all .3s ease",
          _groupHover: {
            color: 'baseWhite'
          },
          color: "baseNeutral.700",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          letterSpacing: "0.25px",
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          fontSize: "sm",
          children: description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        transition: "all .3s ease",
        transform: "translateX(-10px)",
        opacity: 0,
        _groupHover: {
          opacity: '100%',
          transform: 'translateX(0)'
        },
        justify: "flex-end",
        align: "center",
        flex: 1,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
          color: "baseWhite",
          w: 5,
          h: 5,
          as: icons_dist_index_esm/* ChevronRightIcon */.XC
        })
      })]
    })
  });
};

/* harmony default export */ var MenuItem_Desktop = (DesktopItem);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./src/components/Menu/Mobile.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Mobile = function Mobile(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
    bg: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('baseWhite', 'gray.800'),
    textTransform: "uppercase",
    fontSize: "0.875rem",
    children: items.map(function (navItem) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem_Mobile, _objectSpread({}, navItem), navItem.name);
    })
  });
};

/* harmony default export */ var Menu_Mobile = (Mobile);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js + 7 modules
var popover_dist_index_esm = __webpack_require__(81521);
;// CONCATENATED MODULE: ./src/components/Menu/Desktop.tsx


function Desktop_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Desktop_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Desktop_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Desktop_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





/** https://github.com/chakra-ui/chakra-ui/issues/5896 */



var PopoverTrigger = popover_dist_index_esm/* PopoverTrigger */.xo;

var Desktop = function Desktop(_ref) {
  var items = _ref.items;

  var _useState = (0,react.useState)(false),
      isMounted = _useState[0],
      setMount = _useState[1];

  (0,react.useEffect)(function () {
    setMount(true);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
    direction: "row",
    spacing: 4,
    align: "center",
    children: items.map(function (navItem) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        textAlign: "left",
        className: !isMounted && navItem.children && navItem.children.length > 0 ? 'has-popover' : '',
        children: navItem.children && navItem.children.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
          trigger: "hover",
          placement: "bottom-start",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PopoverTrigger, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: navItem.href,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU // href={navItem.href}
              , {
                target: navItem.target,
                whiteSpace: "nowrap",
                color: "baseNeutral.700",
                fontFamily: "Montserrat-SemiBold",
                fontSize: "0.875rem",
                textAlign: "left",
                letterSpacing: "0.25px",
                textTransform: "uppercase",
                _hover: {
                  textDecoration: 'none',
                  color: 'primaryGreen.800'
                },
                dangerouslySetInnerHTML: {
                  __html: navItem.name
                }
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverContent */.yk, {
            border: 0,
            boxShadow: "xl",
            bg: "baseWhite",
            p: 4,
            rounded: "xl",
            minW: "sm",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
              children: navItem.children.map(function (child) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem_Desktop, Desktop_objectSpread({}, child), child.name);
              })
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: navItem.href,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
            target: navItem.target,
            whiteSpace: "nowrap",
            color: "baseNeutral.700",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "0.875rem",
            letterSpacing: "0.25px",
            textTransform: "uppercase",
            _hover: {
              textDecoration: 'none',
              color: 'primaryGreen.800'
            } // href={navItem.href}
            ,
            dangerouslySetInnerHTML: {
              __html: navItem.name
            }
          })
        })
      }, navItem.name);
    })
  });
};

/* harmony default export */ var Menu_Desktop = (Desktop);
// EXTERNAL MODULE: ./src/components/Header/index.tsx
var Header = __webpack_require__(14479);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./src/containers/data/cities.json
var cities = __webpack_require__(82606);
;// CONCATENATED MODULE: ./src/components/Contact/index.tsx







var citiesList = cities.map(function (city) {
  return "<a href=\"".concat(city.href, "\">").concat(city.name, "</a>");
});

var Contact = function Contact(_ref) {
  var image = _ref.image,
      title = _ref.title,
      description = _ref.description,
      action = _ref.action,
      href = _ref.href,
      alt = _ref.alt;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bgColor: "#EFEFF1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
      as: index_esm/* Stack */.Kq,
      maxW: "6xl",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          md: 2
        },
        spacing: "l",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          pt: "xxl3",
          pb: "xxl3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            color: "baseDark",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1.25rem",
            letterSpacing: "0.6px",
            lineHeight: "26px",
            whiteSpace: "pre-wrap",
            mb: "m",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
            color: "baseDark",
            fontFamily: "Montserrat-Medium",
            fontSize: "0.875rem",
            letterSpacing: "0.2px",
            lineHeight: "18px",
            whiteSpace: "pre-wrap",
            pb: "l",
            children: [description, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: citiesList.join(', ')
              }
            }), "."]
          }), action && href && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* InvertedLinkButton */.tz, {
            href: href,
            action: action,
            title: alt
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          display: {
            base: 'none',
            md: 'block'
          },
          position: "relative",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: image,
            alt: title,
            layout: "fill",
            loading: "lazy",
            placeholder: "empty",
            decoding: "async"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var components_Contact = (Contact);
// EXTERNAL MODULE: ./node_modules/@aaronhayes/react-use-hubspot-form/build/module/index.js
var build_module = __webpack_require__(14036);
;// CONCATENATED MODULE: ./src/components/Newsletter/index.tsx






var Newsletter = function Newsletter(_ref) {
  var title = _ref.title,
      description = _ref.description;
  (0,build_module/* useHubspotForm */.k1)({
    portalId: "6886918",
    formId: "53a0159f-88e8-4ed7-b479-9d3d58e4e8b5",
    target: '#newsletter-form'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bg: "primaryGreen.600",
    px: {
      base: '0.375rem',
      md: null
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
      as: index_esm/* Stack */.Kq,
      maxW: "6xl",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        maxW: "6xl",
        py: "xxl",
        templateColumns: {
          base: '1fr',
          md: '4fr 5fr'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          mb: {
            base: 'l',
            md: '0'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            color: "baseWhite",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1.5rem",
            lineHeight: "31px",
            letterSpacing: ".68px",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            color: "baseWhite",
            fontFamily: "Montserrat-SemiBold",
            fontSize: ".875rem",
            lineHeight: "18px",
            letterSpacing: ".2px",
            marginTop: "xs",
            children: description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
          id: "newsletter-form",
          mt: "-1rem",
          fontFamily: "Montserrat-Medium",
          color: "baseWhite"
        })]
      })
    })
  });
};

/* harmony default export */ var components_Newsletter = (Newsletter);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/Slider/index.tsx






var SliderBox = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57199));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(57199)];
    }
  }
});

var Slider = function Slider(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      image = _ref.image,
      boxes = _ref.boxes,
      contactAction = _ref.contactAction,
      contactHref = _ref.contactHref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
    w: "full",
    h: {
      base: '29.375rem',
      md: '34.938rem'
    },
    pb: "9",
    background: "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1)), url(".concat(image, ")"),
    backgroundColor: "white",
    backgroundSize: "cover",
    backgroundPosition: "center top no-repeat",
    marginBottom: "2rem !important",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
      mx: "auto",
      marginTop: {
        md: '12.5rem',
        sm: '2.5rem'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h1",
        color: "baseWhite",
        fontFamily: "Montserrat-SemiBold",
        fontSize: {
          base: '1.5rem',
          md: '2.25rem'
        },
        lineHeight: {
          base: '1.938rem',
          md: '2.925rem'
        },
        letterSpacing: ".67px",
        whiteSpace: "pre-wrap",
        my: {
          base: 'xxl',
          md: '0'
        },
        mx: {
          base: 'safeAreaMobile',
          md: '0'
        },
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        display: {
          base: 'none',
          md: 'block'
        },
        as: "h2",
        color: "baseWhite",
        fontFamily: "Montserrat-Regular",
        fontSize: "1.375rem",
        fontWeight: "normal",
        lineHeight: "1.75rem",
        letterSpacing: ".6px",
        whiteSpace: "pre-wrap",
        marginTop: ".7rem !important",
        marginBottom: "2rem !important",
        children: subtitle
      }), contactAction && contactHref && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        justify: "center",
        mb: "3rem !important",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* InvertedLinkButton */.tz, {
          href: contactHref,
          action: contactAction,
          title: contactAction
        })
      }), boxes && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          sm: 2,
          md: 2
        },
        spacing: {
          base: '2.875rem',
          md: 120
        },
        position: "relative",
        children: boxes.map(function (box) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SliderBox, {
            image: box.image,
            title: box.title,
            description: box.description,
            action: box.action,
            actionMobile: box.actionMobile || null,
            href: box.href,
            alt: box.alt,
            target: box.target
          }, box.title);
        })
      })]
    })
  });
};

/* harmony default export */ var components_Slider = (Slider);
// EXTERNAL MODULE: ./src/components/OfferDetails/index.tsx + 3 modules
var OfferDetails = __webpack_require__(55397);
;// CONCATENATED MODULE: ./src/components/Container/index.tsx




var Container = function Container(_ref) {
  var children = _ref.children,
      paddingY = _ref.paddingY,
      paddingX = _ref.paddingX,
      marginY = _ref.marginY,
      marginX = _ref.marginX;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
    as: index_esm/* Stack */.Kq,
    maxW: "7xl",
    py: "xxl6",
    paddingY: paddingY || 10,
    marginY: marginY,
    paddingX: paddingX || 0,
    marginX: marginX,
    children: children
  });
};

/* harmony default export */ var components_Container = (Container);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/OrganizationSchema/index.tsx
// src/components/OrganizationSchema.tsx




var OrganizationSchema = function OrganizationSchema() {
  var organizationData = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "CarPlanner",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg",
    "description": "CarPlanner offre soluzioni di noleggio auto a lungo termine per privati e aziende in tutta Italia.",
    "sameAs": ["https://www.facebook.com/carplannercom", "https://www.linkedin.com/company/carplanner", "https://twitter.com/CarPlannerIT"]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(organizationData)
      }
    })
  });
};

/* harmony default export */ var components_OrganizationSchema = (OrganizationSchema);
;// CONCATENATED MODULE: ./src/components/index.tsx













/***/ }),

/***/ 82606:
/***/ (function(module) {

module.exports = JSON.parse('[{"name":"Bari","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bari"},{"name":"Bergamo","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bergamo"},{"name":"Bologna","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bologna"},{"name":"Brescia","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/brescia"},{"name":"Catania","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/catania"},{"name":"Firenze","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/firenze"},{"name":"Genova","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/genova"},{"name":"Lecce","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/lecce"},{"name":"Lucca","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/lucca"},{"name":"Milano","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/milano"},{"name":"Modena","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/modena"},{"name":"Monza Brianza","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/monza-brianza"},{"name":"Napoli","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/napoli"},{"name":"Padova","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/padova"},{"name":"Palermo","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/palermo"},{"name":"Parma","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/parma"},{"name":"Prato","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/prato"},{"name":"Roma","image":"/images/colosseo-roma.png","href":"/noleggio-a-lungo-termine/roma"},{"name":"Torino","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/torino"},{"name":"Treviso","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/treviso"},{"name":"Udine","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/udine"},{"name":"Venezia","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/venezia"},{"name":"Verona","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/verona"},{"name":"Vicenza","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/vicenza"}]');

/***/ })

}]);